import React from 'react';

interface ErrorScreenProps {
  title?: string;
  description?: string;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ title, description }) => (
  <div className="w-full h-full md:rounded-2xl! aspect-video bg-black flex">
    <div className="bg-[#151515] text-white w-full h-full flex justify-center items-center p-4">
      <svg
        className="shrink-0 w-10 h-10 m-3 md:w-24 md:h-24 md:m-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div>
        <h3 className="text-base md:text-2xl mb-1 md:mb-2">{title || "Playback Error"}</h3>
        <div className="text-sm md:text-lg">{description || "Unable to play the video. Please try again later."}</div>
      </div>
    </div>
  </div>
); 